import React, { createContext, useContext, useState, useEffect } from "react";
import { API_URL as API } from "./config";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("sv_token") || null);
  const [loading, setLoading] = useState(true);

  // Обработка OAuth-редиректа: ?token=...&user=...
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const oauthToken = params.get("token");
    const oauthUser  = params.get("user");
    if (oauthToken && oauthUser) {
      try {
        const parsed = JSON.parse(oauthUser);
        localStorage.setItem("sv_token", oauthToken);
        setToken(oauthToken);
        setUser(parsed);
      } catch {}
      // Убираем параметры из адресной строки
      window.history.replaceState({}, "", window.location.pathname);
      setLoading(false);
      return;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Проверяем токен при загрузке
  useEffect(() => {
    if (!token) { setLoading(false); return; }
    if (user) { setLoading(false); return; } // уже установлен через OAuth
    fetch(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(u => { setUser(u); setLoading(false); })
      .catch(() => { logout(); setLoading(false); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const login = (newToken, userData) => {
    localStorage.setItem("sv_token", newToken);
    setToken(newToken);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("sv_token");
    setToken(null);
    setUser(null);
  };

  const updateUser = (partial) => {
    setUser(prev => prev ? { ...prev, ...partial } : prev);
  };

  return (
    <AuthContext.Provider value={{
      user,
      token,
      loading,
      login,
      logout,
      updateUser,
      isLoggedIn: !!user,
      isAdmin: user?.role === "admin",
      isEditor: user?.role === "editor" || user?.role === "admin",
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export { API_URL } from "./config";
